import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileContract,
  faTruck,
  faUsers,
  faCalendarCheck,
  faMoneyCheck,
  faChartLine,
} from "@fortawesome/free-solid-svg-icons";

const features = [
  {
    icon: faFileContract,
    title: "Contract Management",
    description: "Track status, timelines, and execution across contract lifecycle.",
  },
  {
    icon: faTruck,
    title: "Vehicle Tracking",
    description: "Monitor fuel, maintenance, insurance, challans, and usage analytics.",
  },
  {
    icon: faUsers,
    title: "Payroll & Attendance",
    description: "Simplified workforce planning with attendance and salary automation.",
  },
  {
    icon: faCalendarCheck,
    title: "Tender & Bidding",
    description: "Manage project bids and tender workflows with full transparency.",
  },
  {
    icon: faMoneyCheck,
    title: "Payments & Estimations",
    description: "Ensure financial clarity with budgeting, billing, and estimates.",
  },
  {
    icon: faChartLine,
    title: "Insightful Dashboards",
    description: "Visualize KPIs and project health in real time with reports.",
  },
];

const FeaturesSection: React.FC = () => {
  return (
    <section className="py-16 px-6 max-w-7xl mx-auto text-center">
      <h2 className="text-3xl font-bold mb-8">Core Features of Tadwiro</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {features.map((feature) => (
          <div
            key={feature.title}
            className="bg-white rounded shadow p-6 hover:shadow-lg transition"
          >
            <FontAwesomeIcon icon={feature.icon} className="text-blue-600 text-3xl mb-4" />
            <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
            <p className="text-gray-600">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FeaturesSection;